import client from '../../lib/api/client';

export const writeTower = ({ title, body, tags, project }) => {
    return client.post('/api/towers', {
        title,
        body,
        tags,
        project,
    });
};

export const readTower = (id) => {
    return client.get(`/api/towers/${id}`);
};

export const listTower = ({ projectId, page, username, tag }) => {
    return client.get('/api/towers', {
        params: { projectId, page, username, tag },
    });
};

export const updateTower = ({ id, title, body, tags }) => {
    return client.patch(`/api/towers/${id}`, {
        title,
        body,
        tags,
    });
};

export const removeTower = (id) => {
    return client.delete(`/api/towers/${id}`);
};
